// extracted by mini-css-extract-plugin
export default {"titleHolder":"titleHolder---pC756","title":"title---K6Le0","icon":"icon---kWU6D"};